module.exports = __webpack_public_path__ + "img/Andromeda.0eb37d00.png";